export default {
    mapper: {},
    customIndexes: {
        noteable_id: ['noteable_id', 'noteable_type'],
    },
};
